/* eslint-disable max-len */
import { isEqual } from 'lodash';
import api from '@/services/api';

export default {
  namespaced: true,
  state: {
    chartData: [],
    latestChartParams: {},
  },
  mutations: {
    setLatestChartParams(state, value) {
      state.latestChartParams = value;
    },
    setChartData(state, value) {
      state.chartData = value;
    },
  },
  actions: {
    getMarketChartData({ commit, state }, { params, cache = false }) {
      if (cache && state.latestChartParams && isEqual(params, state.latestChartParams)) {
        return Promise.resolve(state.chartData);
      }
      return api.chart.getMarketChartData(params)
        .then((response) => {
          const data = response.data;
          commit('setLatestChartParams', params);
          commit('setChartData', data);
          return data;
        });
    },
    getContractChartData({ commit }, { contractId, timeline }) {
      return api.chart.getContractChartData(contractId, timeline)
        .then(response => response.data);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/chart.js